import { render } from "./InstallSuccess.vue?vue&type=template&id=332d6d0b&ts=true"
import script from "./InstallSuccess.vue?vue&type=script&lang=ts"
export * from "./InstallSuccess.vue?vue&type=script&lang=ts"

import "./InstallSuccess.vue?vue&type=style&index=0&id=332d6d0b&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__